import React from 'react';
import { Moon, Smartphone, Briefcase, UtensilsCrossed } from 'lucide-react';
export function SleepSection() {
  return <section className="py-20 lg:py-32 px-6 bg-charcoal text-cream" data-id="element-216">
      <div className="max-w-6xl mx-auto" data-id="element-217">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-218">
          <div className="order-2 lg:order-1" data-id="element-219">
            <div className="relative" data-id="element-220">
              {/* Circle Graphic */}
              <div className="aspect-square rounded-full border border-white/10 relative p-12 flex flex-col items-center justify-center text-center" data-id="element-221">
                <div className="absolute inset-0 border border-white/5 rounded-full scale-90" data-id="element-222"></div>
                <div className="absolute inset-0 border border-white/5 rounded-full scale-75" data-id="element-223"></div>

                <h3 className="text-3xl font-serif text-gold mb-2" data-id="element-224">
                  The 3-2-1 Rule
                </h3>
                <p className="text-sm text-cream/50 uppercase tracking-widest mb-8" data-id="element-225">
                  Pre-Sleep Protocol
                </p>

                <div className="space-y-6 w-full max-w-xs" data-id="element-226">
                  <div className="flex items-center gap-4" data-id="element-227">
                    <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0" data-id="element-228">
                      <span className="font-serif font-bold text-lg" data-id="element-229">3</span>
                    </div>
                    <div className="text-left" data-id="element-230">
                      <p className="text-sm font-medium text-white" data-id="element-231">
                        Hours before bed
                      </p>
                      <p className="text-xs text-cream/60" data-id="element-232">
                        No food (digestion keeps you awake)
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-233">
                    <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0" data-id="element-234">
                      <span className="font-serif font-bold text-lg" data-id="element-235">2</span>
                    </div>
                    <div className="text-left" data-id="element-236">
                      <p className="text-sm font-medium text-white" data-id="element-237">
                        Hours before bed
                      </p>
                      <p className="text-xs text-cream/60" data-id="element-238">
                        No work (cortisol spike)
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-239">
                    <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0" data-id="element-240">
                      <span className="font-serif font-bold text-lg" data-id="element-241">1</span>
                    </div>
                    <div className="text-left" data-id="element-242">
                      <p className="text-sm font-medium text-white" data-id="element-243">
                        Hour before bed
                      </p>
                      <p className="text-xs text-cream/60" data-id="element-244">
                        No blue light (melatonin blocker)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2" data-id="element-245">
            <span className="text-gold font-serif italic text-xl mb-4 block" data-id="element-246">
              Chapter 5
            </span>
            <h2 className="text-4xl lg:text-5xl font-serif text-white mb-6" data-id="element-247">
              The Deep-State Sleep Protocol
            </h2>
            <p className="text-lg text-cream/80 mb-8 leading-relaxed" data-id="element-248">
              Cortisol should be high in the morning and low at night. If yours
              is reversed, you won't lose weight.
            </p>

            <div className="bg-sage/20 p-8 rounded-sm border border-sage/30" data-id="element-249">
              <h3 className="text-xl font-serif text-white mb-3 flex items-center gap-2" data-id="element-250">
                <Moon className="w-5 h-5 text-gold" data-id="element-251" />
                The Magnesium Connection
              </h3>
              <p className="text-cream/70 leading-relaxed" data-id="element-252">
                Use Magnesium Glycinate 30 mins before bed. It "mutes" the
                adrenal response so your brain can enter REM.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}